"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareTask = void 0;
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _SocialShare = require("../../../Content/SocialShare");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _encoders = require("../../../utilities/encoders");
var _urls = require("../../../utilities/urls");
var _jsxRuntime = require("react/jsx-runtime");
var ShareTask = function ShareTask(props) {
  var handleClose = props.handleClose,
    shareItemUrl = props.shareItemUrl,
    isLearningActivity = props.isLearningActivity;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    getLabel = _useContext.getLabel,
    isSavedItem = _useContext.isSavedItem,
    setIsShareItem = _useContext.setIsShareItem,
    task = _useContext.task;
  var _useContext2 = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    siteKey = _useContext2.siteKey,
    siteName = _useContext2.siteName;
  var taskUrl = isLearningActivity ? "".concat(_urls.learningUrl, "/player/assignment/").concat(task === null || task === void 0 ? void 0 : task.id) : "".concat(_urls.lo, "/player/?task=").concat(task === null || task === void 0 ? void 0 : task.id, "&sitekey=").concat(siteKey);
  var shareUrl = shareItemUrl || taskUrl;
  var whatsappText = getLabel('share_whatsapp_startText') + (siteName || getLabel('share_whatsapp_site'));
  var handleGoBack = function handleGoBack() {
    setIsShareItem(false);
  };
  if (!isSavedItem) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialShare.SocialShare, {
    layout: "inline",
    onClose: handleClose,
    onBack: handleGoBack,
    shareList: ['link', 'whatsapp', 'googleClassroom', 'teams'],
    summary: (task === null || task === void 0 ? void 0 : task.guideLines) && (0, _encoders.htmlDecode)(task.guideLines) || '',
    title: (task === null || task === void 0 ? void 0 : task.name) || '',
    url: shareUrl,
    messageLineText: getLabel('share_message'),
    whatsappText: whatsappText
  });
};
exports.ShareTask = ShareTask;